

export const paginationComponentOptions = {
    rangeSeparatorText: 'de',
    rowsPerPageText: 'Registros por página',
};